import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export interface PasswordGeneratorState {
    uppercase: boolean,
    numbers: boolean,
    symbols: boolean,
    length: number,
    output: string,
    outputCopied: boolean,
}

const initialState: PasswordGeneratorState = {
    uppercase: true,
    numbers: true,
    symbols: true,
    length: 8,
    output: "",
    outputCopied: false,
}

export const PasswordGeneratorSlice = createSlice({
    name: 'passwordGenerator',
    initialState,
    reducers: {
        uppercaseOnChanged(state, action: PayloadAction<boolean>) {
            state.uppercase = action.payload;
        },

        numbersOnChanged(state, action: PayloadAction<boolean>) {
            state.numbers = action.payload;
        },
        symbolsOnChanged(state, action: PayloadAction<boolean>) {
            state.symbols = action.payload;
        },
        lengthOnChanged(state, action: PayloadAction<number>) {
            state.length = action.payload;
        },
        outputOnChanged(state, action: PayloadAction<string>) {
            state.output = action.payload;
        },
        outputCopiedTapped: (state) => {
            state.outputCopied = true;
        },
    }
});

export const generatePassword = createAsyncThunk<void, void, { state: RootState }>(
    'password/generatePassword',
    async (_, { getState, dispatch }) => {
        const state = getState().passwordGenerator;


        const LOWERCASE_CHARS = 'abcdefghijklmnopqrstuvwxyz';
        const UPPERCASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const SYMBOL_CHARS = '!@#$%^&*()_+[]{}|;:,.<>?';
        const NUMERIC_CHARS = '0123456789';

        let charPool = LOWERCASE_CHARS;

        if (state.numbers) charPool += NUMERIC_CHARS;
        if (state.uppercase) charPool += UPPERCASE_CHARS;
        if (state.symbols) charPool += SYMBOL_CHARS;

        if (charPool.length === 0) {
            dispatch(outputOnChanged(''));
            return;
        }

        let password = '';
        for (let i = 0; i < state.length; i++) {
            const randomIndex = Math.floor(Math.random() * charPool.length);
            password += charPool[randomIndex];
        }

        dispatch(outputOnChanged(password));
    }
);

export const {
    uppercaseOnChanged,
    numbersOnChanged,
    symbolsOnChanged,
    lengthOnChanged,
    outputOnChanged,
    outputCopiedTapped,
} = PasswordGeneratorSlice.actions;

export const selectState = (state: RootState) => state.passwordGenerator;

export default PasswordGeneratorSlice.reducer;